import type { IResponse } from '@/features/api/extranet'
import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export async function loadFacture(code: string, init?: RequestInit): Promise<FactureDTO> {
  init = { ...{ sablier: true, dialogMode: 'retry' }, ...(init ?? {}) }

  const fetch = useFetch('extranet')
  const response = await fetch(`/factures/${code}`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<FactureDTO>

  return result.data
}
